var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.84375C4.71875 1.84375 2.09375 4.49609 2.09375 7.75C2.09375 11.0312 4.71875 13.6562 8 13.6562C11.2539 13.6562 13.9062 11.0312 13.9062 7.75C13.9062 4.49609 11.2266 1.84375 8 1.84375ZM8 0.96875C11.7188 0.96875 14.7812 4.03125 14.7812 7.75C14.7812 11.4961 11.7188 14.5312 8 14.5312C4.25391 14.5312 1.21875 11.4961 1.21875 7.75C1.21875 4.03125 4.25391 0.96875 8 0.96875ZM7.01562 10.375H7.34375V7.09375H7.01562C6.82422 7.09375 6.6875 6.95703 6.6875 6.76562V6.54688C6.6875 6.38281 6.82422 6.21875 7.01562 6.21875H8.32812C8.49219 6.21875 8.65625 6.38281 8.65625 6.54688V10.375H8.98438C9.14844 10.375 9.3125 10.5391 9.3125 10.7031V10.9219C9.3125 11.1133 9.14844 11.25 8.98438 11.25H7.01562C6.82422 11.25 6.6875 11.1133 6.6875 10.9219V10.7031C6.6875 10.5391 6.82422 10.375 7.01562 10.375ZM8 3.8125C8.46484 3.8125 8.875 4.22266 8.875 4.6875C8.875 5.17969 8.46484 5.5625 8 5.5625C7.50781 5.5625 7.125 5.17969 7.125 4.6875C7.125 4.22266 7.50781 3.8125 8 3.8125Z",
    fill: "#FFA800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.d55d5ad9f5024fcb278a1966b7ae2b01.svg";
export { ForwardRef as ReactComponent };